export const PAGE_ANALYTICS_SCREEN_ANALYTICS_SOURCE = 'analyticsPageScreen';
export const VIEWS_TAB_ANALYTICS_KEY = 'views';
export const MENTIONS_TAB_ANALYTICS_KEY = 'mentions';
export const VIEWS_TAB_KEY = 'page-analytics-views-tab';
export const MENTIONS_TAB_KEY = 'page-analytics-mentions-tab';
export const TABS_UI_ID = 'page-analytics-tabs';
